module.exports = __webpack_public_path__ + "img/in-money.4a7a5a82.png";